<template>
  <div
    style="flex-shrink: 1"
    :style="{ width: tableSize + '%' }"
  >
    <div
      v-if="isLoadingList"
      class="table-list__loading"
    >
      <Spinner />
    </div>
    <template v-else>
      <div
        v-if="list && list.length > 0"
        class="table-list"
      >
        <div class="header-row">
          <div
            v-for="(column, index) in columns"
            :key="column.name"
            :style="{ width: column.widthPercent + '%', 'justify-content': column.textPosition }"
            @click="orderByColumn(column.propName, index)"
          >
            {{ column.name }}

            <svg-loader
              src="/static/images/icon-sort-arrow.svg"
              class="arrow-direction"
              :class="{
                'arrow-direction__down': actualColumnSortType === index && sortDirection === 'asc',
                'arrow-direction__up': actualColumnSortType === index && sortDirection === 'desc'
              }"
            />
          </div>
        </div>
        <div
          v-for="(item, i) in list"
          :key="'sub-' + i"
          class="data-row"
          @click="handleClickRow(item)"
        >
          <div
            v-for="(column, index) in columns"
            :key="index"
            :style="{
              width: column.widthPercent + '%',
              textAlign: column.textPosition,
              color: column.propName === 'value' && isDebit(item)
            }"
          >
            <template v-if="column.name === 'Detalhe' && item[column.propName]">
              <div class="details">
                <span
                  class="details__text"
                  @click.stop="handleClickItem(item)"
                >
                  {{ item[column.propName] }}
                </span>
                <span class="details__tooltip">
                  Ver Detalhes
                </span>
              </div>
            </template>
            <template v-else-if="column.valueToSwitchIfThisPropIsZero && item[column.propName] <= 0">
              {{ formatSwitchedValue(item[column.valueToSwitchIfThisPropIsZero], column.valueType) }}
              <md-tooltip>*Preço não negociado</md-tooltip>
            </template>
            <template v-else>
              {{ formatValue(item[column.propName], column.valueType) }}
            </template>
          </div>
        </div>
      </div>
      <div
        v-else
        class="empty-list"
      >
        <img
          src="/static/images/empty-list.svg"
          alt="Lista Vazia de faturas"
        >
        Não possui dados para esta lista
      </div>
    </template>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'

export default {
  name: 'TableList',
  components: {
    Spinner
  },
  props: {
    list: {
      type: Array
    },
    columns: {
      type: Array,
      required: true
    },
    isLoadingList: {
      type: Boolean,
      required: true
    },
    tableSize: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      currentPage: 0,
      actualColumnSortType: null,
      sortDirection: null
    }
  },
  methods: {
    handleClickRow(item) {
      this.$emit('clickRow', item)
    },
    handleClickItem(item) {
      this.$emit('clickItem', item)
    },
    orderByColumn(column, index) {
      const sortType = this.actualColumnSortType === index ? (this.sortDirection === 'asc' ? 'desc' : 'asc') : 'desc'
      this.sortDirection = sortType
      this.actualColumnSortType = index

      this.$emit('orderBy', { column, sortType })
    },
    format(value, type) {
      if (type === 'R$' || type === '%') {
        return this.addPunctuation(value, type)
      }
      if (type === 'number') {
        return this.formatNumberWithPunctuation(value)
      }
    },
    addPunctuation(value, type) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      let symbol = ''
      if (type === 'R$') {
        symbol = 'R$ '
      } else if (type === '%') {
        symbol = ''
        val += '%'
      }
      return `${symbol}${value !== 0 ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '0,00'}`
    },
    formatNumberWithPunctuation(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatValue(value, type) {
      return type ? this.format(value, type) : value
    },
    formatSwitchedValue(value, type) {
      return type ? this.format(value, type) + '*' : value + '*'
    },
    isDebit(value) {
      return value.type === 'DEBITAR' ? '#BB230C' : '#52CC9C'
    }
  }
}
</script>

<style lang="scss">
  .table-list {
    margin: 0;
    margin-bottom: 24px;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
    font-family: 'Exo 2', sans-serif !important;
    padding: 0 18px;

    &__loading {
      margin: 100px 0;
    }

    .header-row,
    .data-row {
      display: flex;
    }

    .header-row {
      font-weight: bold;
      border-bottom: 2px solid #797979;
      cursor: pointer;

      div {
        padding: 10px 10px 10px 0;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        font-size: 11px;
        font-weight: 900;
        color: #717171;
        text-transform: uppercase;
        justify-content: space-between;

        &:last-child {
          padding-right: 0;
        }
      }

      .arrow-direction {
        margin: 0;
        margin-left: 4px;
        width: 13px;
        min-width: 13px;

        svg {
          width: 13px;
        }

        &__up {
          .icon-sort-arrow-up {
            fill: #dbdbdb;
          }
        }

        &__down {
          .icon-sort-arrow-down {
            fill: #dbdbdb;
          }
        }
      }
    }

    .data-row {
      border-bottom: 1px solid #eee;
      padding: 14px 0px;

      div {
        text-align: left;
        color: #797979;
        background-color: #fff;
        line-height: 14px;
        font-size: 13px;
        padding-right: 8px;

        &:last-child {
          padding-right: 8px;
        }
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .invoicing {
    .empty-list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 110px auto;
      color: #999999;
      font-size: 23px;

      img {
        margin-bottom: 24px;
      }
    }
  }

  .details{
    position: relative;
    width: max-content;
    &__text{
      cursor: pointer;
      color: #0037FF;
      text-decoration: underline;
      display: block;
      &:hover + .details__tooltip {
        opacity: 1;
        z-index: 10;
      }
    }

    &__tooltip {
      position: absolute;
      top: -40px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #818181;
      padding: 10px;
      border-radius: 8px;
      white-space: nowrap;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      z-index: -10;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
      color: #ffffff;
      font-family: Exo 2;
      font-weight: 500;
      font-size: 13.33px;
      line-height: 100%;
      letter-spacing: 0px;


      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 5px;
        border-style: solid;
        border-color: #818181 transparent transparent transparent;
      }
    }
  }
</style>
